"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[567],{

/***/ 49932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ SignUpFormContainer; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63602);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var yup_es = __webpack_require__(65413);
// EXTERNAL MODULE: ./src/components/app/authForms/signUpForm/styles.tsx
var styles = __webpack_require__(22051);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
// EXTERNAL MODULE: ./src/components/uielements/checkbox/styles.tsx
var checkbox_styles = __webpack_require__(1855);
// EXTERNAL MODULE: ./src/components/uielements/favoriteLocationsDropdownField/favorite-locations-dropdown-field.tsx
var favorite_locations_dropdown_field = __webpack_require__(68580);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/styles.ts
var form_fields_styles = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/components/uielements/formik/index.tsx + 3 modules
var formik = __webpack_require__(83269);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/constants/authentication.ts
var authentication = __webpack_require__(5125);
// EXTERNAL MODULE: ./src/constants/features.ts
var features = __webpack_require__(51710);
// EXTERNAL MODULE: ./src/constants/validation.ts
var validation = __webpack_require__(38885);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
// EXTERNAL MODULE: ./src/utils/features.ts + 1 modules
var utils_features = __webpack_require__(38732);
;// CONCATENATED MODULE: ./src/components/app/authForms/signUpForm/form.tsx

















function SignUpForm(param) {
    var doSignUp = param.doSignUp, loading = param.loading;
    var organization = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization;
    });
    var ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }), strings = ref.strings, webConfig = ref.webConfig;
    var loyaltyDriverID = organization.organization.loyalty_driver_id;
    var appState = (0,redux/* useSelector */.v9)(function(state) {
        return state.app;
    });
    var FeatureHandler = new utils_features/* KoalaFeatureHandler */.n(appState);
    var isEnabled = function(field) {
        var registrationFields = organization.external_auth.registration_fields.user;
        var optionalFields = (0,auth/* getSignupOptionalFields */.A5)(loyaltyDriverID);
        // @ts-expect-error field can't index `accounts`.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var cmsConfigFieldValue = webConfig.accounts[field];
        if (!(registrationFields === null || registrationFields === void 0 ? void 0 : registrationFields.includes(field)) && !(optionalFields === null || optionalFields === void 0 ? void 0 : optionalFields.includes(field))) {
            return false;
        }
        // Check CMS config
        if (cmsConfigFieldValue === false || cmsConfigFieldValue === "disabled") {
            return false;
        }
        return true;
    };
    var initialValues = {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
        zip_code: undefined,
        invite_code: undefined,
        birthday: undefined,
        terms_and_conditions: false,
        favorite_location_id: undefined
    };
    // only add a value for opt_in if the field is enabled
    if (isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.OPT_IN */.ZV.OPT_IN) && (strings === null || strings === void 0 ? void 0 : strings.signup.opt_in)) {
        var ref1;
        initialValues.opt_in = (ref1 = webConfig.accounts) === null || ref1 === void 0 ? void 0 : ref1.opt_in_auto_select;
    }
    // Validation schema for the reset form.
    var validationSchema = (0,yup_es/* object */.Ry)({
        first_name: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED),
        last_name: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED),
        email: (0,yup_es/* string */.Z_)().email(validation/* VALIDATION_STRINGS.EMAIL */.xz.EMAIL).required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED),
        phone: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED).matches(validation/* REGEX.PHONE */.mL.PHONE, validation/* REGEX_VALIDATION_STRINGS.PHONE */.r7.PHONE),
        password: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED).min(8, validation/* VALIDATION_STRINGS.PASSWORD_LENGTH */.xz.PASSWORD_LENGTH),
        zip_code: (0,yup_es/* lazy */.Vo)(function() {
            return (webConfig.accounts.zip_code === "required" ? (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED) : (0,yup_es/* string */.Z_)().optional()).matches(validation/* REGEX.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA */.mL.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA, {
                message: validation/* REGEX_VALIDATION_STRINGS.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA */.r7.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA
            });
        }),
        favorite_location_id: (0,yup_es/* lazy */.Vo)(function() {
            return webConfig.accounts.favorite_location === "required" && FeatureHandler.isFeatureAllowed(features/* FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED */.y8.ACCOUNT__FAVORITE_LOCATIONS_ENABLED) ? (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED) : (0,yup_es/* string */.Z_)().optional();
        }),
        invite_code: (0,yup_es/* lazy */.Vo)(function() {
            return (0,yup_es/* string */.Z_)().optional();
        }),
        birthday: (0,yup_es/* lazy */.Vo)(function() {
            return (isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.BIRTHDAY */.ZV.BIRTHDAY) ? (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED) : (0,yup_es/* string */.Z_)().optional()).matches(validation/* REGEX.MM_DD_YYYY_DASHES_SLASHES */.mL.MM_DD_YYYY_DASHES_SLASHES, validation/* REGEX_VALIDATION_STRINGS.MM_DD_YYYY_DASHES_SLASHES */.r7.MM_DD_YYYY_DASHES_SLASHES);
        }),
        opt_in: (0,yup_es/* lazy */.Vo)(function() {
            return isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.OPT_IN */.ZV.OPT_IN) && (strings === null || strings === void 0 ? void 0 : strings.signup.opt_in) ? (0,yup_es/* boolean */.O7)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED) : (0,yup_es/* boolean */.O7)().optional();
        }),
        terms_and_conditions: (0,yup_es/* lazy */.Vo)(function() {
            return isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.TERMS_AND_CONDITIONS */.ZV.TERMS_AND_CONDITIONS) && (strings === null || strings === void 0 ? void 0 : strings.signup.accept_terms_conditions) ? (0,yup_es/* boolean */.O7)().oneOf([
                true
            ], validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED) : (0,yup_es/* boolean */.O7)().optional();
        })
    });
    var accessor = loading ? "signup.cta_loading" : "signup.cta";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        onSubmit: doSignUp,
        initialValues: initialValues,
        validationSchema: validationSchema,
        children: function(param) {
            var handleChange = param.handleChange, errors = param.errors, touched = param.touched;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                "data-testid": "sign-up-form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "first_name",
                                    name: "first_name",
                                    placeholder: "First Name",
                                    type: "text"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "last_name",
                                    name: "last_name",
                                    placeholder: "Last Name",
                                    type: "text"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "email",
                                    name: "email",
                                    placeholder: "Email",
                                    type: "text"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "phone",
                                    name: "phone",
                                    type: "tel",
                                    placeholder: "Phone Number"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    placeholder: "Password",
                                    autoComplete: "off"
                                })
                            }),
                            isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.ZIP_CODE */.ZV.ZIP_CODE) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "zip_code",
                                    name: "zip_code",
                                    type: "text",
                                    placeholder: "Zip Code",
                                    maxLength: 10
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.REFERRAL_CODE */.ZV.REFERRAL_CODE) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "invite_code",
                                    name: "invite_code",
                                    type: "text",
                                    placeholder: "Referral Code (optional)"
                                })
                            }) : null,
                            isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.BIRTHDAY */.ZV.BIRTHDAY) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                    label: "",
                                    id: "birthday",
                                    name: "birthday",
                                    type: "text",
                                    placeholder: "Birthday"
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(favorite_locations_dropdown_field/* FavoriteLocationDropdownField */.K, {
                            input: {
                                name: "favorite_location_id",
                                placeholder: "favorite_location_id"
                            },
                            handleChange: handleChange,
                            // TODO: When we move Favorite Location Dropdown field into formik input
                            // we might want to how we show error here
                            // NOTE: Added touched to be able to surface error only when field has been touched
                            errorMessage: touched.favorite_location_id ? errors.favorite_location_id : undefined
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        children: isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.TERMS_AND_CONDITIONS */.ZV.TERMS_AND_CONDITIONS) && (strings === null || strings === void 0 ? void 0 : strings.signup.accept_terms_conditions) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                                htmlFor: "terms_and_conditions",
                                className: "control control--checkbox",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        accessor: "signup.accept_terms_conditions",
                                        html: true,
                                        dataObj: {
                                            brandName: organization.organization.label
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                        id: "terms_and_conditions",
                                        name: "terms_and_conditions",
                                        type: "checkbox",
                                        label: strings.signup.accept_terms_conditions
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-testid": "terms-and-conditions-checkbox",
                                        className: "control__indicator"
                                    })
                                ]
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        children: isEnabled(authentication/* SIGNUP_OPTIONAL_FIELDS.OPT_IN */.ZV.OPT_IN) && (strings === null || strings === void 0 ? void 0 : strings.signup.opt_in) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                                htmlFor: "opt_in",
                                className: "control control--checkbox",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        accessor: "signup.opt_in",
                                        html: true,
                                        dataObj: {
                                            brandName: organization.organization.label
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                        id: "opt_in",
                                        name: "opt_in",
                                        type: "checkbox",
                                        label: strings.signup.opt_in
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-testid": "opt-in-checkbox",
                                        className: "control__indicator"
                                    })
                                ]
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSubmitButtonRow */.U, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton_styles/* StyledPrimaryButton */.D, {
                            "data-testid": "signup-button",
                            type: "submit",
                            submitting: loading,
                            buttonTheme: "secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: accessor
                            })
                        })
                    })
                ]
            });
        }
    });
}
var Row = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    flexWrap: "wrap"
});
var Label = (0,stitches/* styled */.zo)("label", {
    display: "flex"
});
var Checkbox = (0,stitches/* styled */.zo)(checkbox_styles/* StyledCheckbox */.P, {
    "& a": {
        color: "$accentPrimary",
        fontSize: "$primary"
    },
    "& div[role=alert]": {
        top: "$4",
        left: "0"
    }
});

// EXTERNAL MODULE: ./src/components/uielements/recaptcha/index.tsx
var recaptcha = __webpack_require__(18368);
// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var actions = __webpack_require__(45479);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
;// CONCATENATED MODULE: ./src/components/app/authForms/signUpForm/index.tsx



















function SignUpFormContainer() {
    var dispatch = (0,es.useDispatch)();
    var loading = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.auth.loading;
    });
    var loyaltyDriverID = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization.loyalty_driver_id;
    });
    var ref = (0,react.useState)(undefined), recaptchaRef = ref[0], setRecaptchaRef = ref[1];
    var signUpFactory = function(formValues, captchaResponse) {
        // Respect the referrer ONLY if we're on the login page
        var referrer = (0,global/* parseReferrer */.PA)((router_default()));
        var payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues, (0,auth/* getExtraSignupPayload */.TQ)(loyaltyDriverID)), {
            captcha_response: captchaResponse !== null && captchaResponse !== void 0 ? captchaResponse : undefined
        });
        dispatch(actions/* default.signUp */.Z.signUp(payload, referrer));
        // If we're using a captcha, reset the captcha
        if (captchaResponse) {
            var ref;
            recaptchaRef === null || recaptchaRef === void 0 ? void 0 : (ref = recaptchaRef.current) === null || ref === void 0 ? void 0 : ref.reset();
        }
    };
    var checkReCaptcha = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formValues) {
            var normalizedFormValues, captchaResponse, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        normalizedFormValues = Object.assign({}, formValues);
                        if (normalizedFormValues.birthday) {
                            if ((0,utils_dates/* isValidDate */.qb)(/** @TODO ensure that `birthday` is defined. */ // @ts-expect-error
                            (0,utils_dates/* getDate */._3)(formValues.birthday, dates/* DATE_FORMAT.MONTH_DAY_YEAR_DASHED */.z.MONTH_DAY_YEAR_DASHED))) {
                                normalizedFormValues.birthday = (0,utils_dates/* formatDate */.p6)(/** @TODO ensure that `birthday` is defined. */ // @ts-expect-error
                                (0,utils_dates/* getDate */._3)(formValues.birthday, dates/* DATE_FORMAT.MONTH_DAY_YEAR_DASHED */.z.MONTH_DAY_YEAR_DASHED), dates/* DATE_FORMAT.YEAR_MONTH_DAY_DASHED */.z.YEAR_MONTH_DAY_DASHED);
                            } else {
                                normalizedFormValues.birthday = (0,utils_dates/* formatDate */.p6)(/** @TODO ensure that `birthday` is defined. */ // @ts-expect-error
                                (0,utils_dates/* getDate */._3)(formValues.birthday, dates/* DATE_FORMAT.MONTH_DAY_YEAR */.z.MONTH_DAY_YEAR), dates/* DATE_FORMAT.YEAR_MONTH_DAY_DASHED */.z.YEAR_MONTH_DAY_DASHED);
                            }
                        }
                        if (!(recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current)) return [
                            3,
                            6
                        ];
                        captchaResponse = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            Promise.race([
                                recaptchaRef.current.executeAsync(),
                                (0,utils/* sleep */._v)(5000)
                            ])
                        ];
                    case 2:
                        // if after 5 seconds reCAPTCHA has not resolved
                        // continue through the registration flow and let the API errors propagate
                        captchaResponse = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        errorReporter/* captureException */.Tb(error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        signUpFactory(normalizedFormValues, captchaResponse);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        signUpFactory(normalizedFormValues);
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function checkReCaptcha(formValues) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm, {
                loading: loading,
                doSignUp: checkReCaptcha
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(recaptcha/* default */.Z, {
                onRef: setRecaptchaRef,
                forwardRef: recaptchaRef,
                // Captcha is not supported for sign up!
                // we mount ReCaptcha component anyway because captcha
                // response is forwarded through to the login flow
                action: authentication/* CAPTCHA_CONFIG.API_ACTIONS.LOGIN */.i5.API_ACTIONS.LOGIN
            })
        ]
    });
}


/***/ }),

/***/ 22051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ StyledSubmitButtonRow; },
/* harmony export */   "n": function() { return /* binding */ StyledSignUpCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73393);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  button {\n    margin: 0 auto;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledSignUpCheckbox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-61a7047-0"
})(function(param) {
    var theme = param.theme;
    return {
        alignItems: "flex-start",
        display: "flex",
        width: "100%",
        "a, button": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            background: "none",
            border: "none",
            color: theme.global.primary_active_color,
            cursor: "pointer",
            textDecoration: "underline"
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFontStyles */ .l)(theme.text.primary_font, [
            "font_size",
            "line_height"
        ], {
            line_height: function(value) {
                return typeof value === "number" ? value : 22;
            }
        })),
        button: {
            paddingLeft: "5px"
        }
    };
});
var StyledSubmitButtonRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-61a7047-1"
})(_templateObject());


/***/ }),

/***/ 1855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ StyledCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8782);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _utils_safePolished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68902);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  opacity: ",
        ";\n  pointer-events: ",
        ";\n  position: relative;\n  overflow: hidden;\n\n  ",
        "\n\n  p {\n    bottom: 5px;\n    color: ",
        ";\n    font-size: 12px;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n  }\n\n  .control {\n    font-size: ",
        "px;\n    position: relative;\n    display: flex;\n    margin-bottom: 20px;\n    padding-left: 30px;\n    cursor: pointer;\n    line-height: 22px;\n    text-align: left;\n\n    a {\n      text-decoration: none;\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .control input {\n    left: 0px;\n    opacity: 0;\n    position: absolute;\n    z-index: -1;\n  }\n\n  .control__indicator {\n    position: absolute;\n    top: 0px;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    background: white;\n    border: 2px solid ",
        ";\n    border-radius: 4px;\n  }\n\n  .control--radio .control__indicator {\n    border-radius: 50%;\n  }\n\n  /* Focus states */\n  .control--checkbox input:focus ~ .control__indicator {\n    border: 2px solid ",
        ";\n  }\n\n  /* Checked state */\n  .control input:checked ~ .control__indicator {\n    background: ",
        ";\n    border: 2px solid ",
        ";\n  }\n\n  /* Focus state whilst checked */\n  .control--checkbox input:checked:focus ~ .control__indicator {\n    background: ",
        ";\n    border: 2px solid ",
        ";\n  }\n\n  .control--radio input:checked:focus ~ .control__indicator {\n    border: 2px solid ",
        ";\n  }\n\n  /* Disabled state */\n  .control input:disabled ~ .control__indicator {\n    pointer-events: none;\n    opacity: .6;\n    background: #e6e6e6;\n  }\n\n  /* Check mark */\n  .control__indicator:after {\n    position: absolute;\n    display: none;\n    content: '';\n  }\n\n  /* Show check mark */\n  .control input:checked ~ .control__indicator:after {\n    display: block;\n  }\n\n  /* Checkbox tick */\n  .control--checkbox .control__indicator:after {\n    top: 2px;\n    left: 5px;\n    width: 4px;\n    height: 9px;\n    transform: rotate(45deg);\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n  }\n\n  /* Disabled tick colour */\n  .control--checkbox input:disabled ~ .control__indicator:after {\n    border-color: #7b7b7b;\n  }\n\n  /* Radio button inner circle */\n  .control--radio input:checked ~ .control__indicator {\n    background: white;\n    border: 1px solid ",
        ";\n  }\n  .control--radio .control__indicator:after {\n    top: 0;\n    left: -1px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: transparent url('/img/radio-selected.svg') no-repeat 0 0;\n  }\n\n  /* Disabled circle colour */\n  .control--radio input:disabled ~ .control__indicator:after {\n    background: #7b7b7b;\n  }\n}"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var _font_size;
var StyledCheckbox = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-308bcb91-0"
})(_templateObject(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? 0.3 : 1;
}, function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "none" : "all";
}, function(param) {
    var width = param.width;
    return width && "\n    width: ".concat(width, "%;\n  ");
}, function(param) {
    var theme = param.theme;
    return theme.global.error_color;
}, function(param) {
    var theme = param.theme;
    return (_font_size = theme.text.primary_font.font_size) !== null && _font_size !== void 0 ? _font_size : 16;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .COLORS.PRIMARY_NAVY_X_LIGHT */ .DM.PRIMARY_NAVY_X_LIGHT, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
}, function(param) {
    var theme = param.theme;
    return (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_3__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_4__/* .darken */ ._j)(0.1, theme.global.primary_active_color);
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .COLORS.PRIMARY_NAVY_X_LIGHT */ .DM.PRIMARY_NAVY_X_LIGHT);


/***/ }),

/***/ 68580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ FavoriteLocationDropdownField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56580);
/* harmony import */ var _components_featureAccessor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88917);
/* harmony import */ var _components_uielements_form_fields_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73081);
/* harmony import */ var _components_uielements_selectCheckout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24274);
/* harmony import */ var _constants_features__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51710);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86879);
/* harmony import */ var _redux_locations_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17464);
/* harmony import */ var _utils_locations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52591);
/* harmony import */ var _utils_magicBox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39916);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60738);












function FavoriteLocationDropdownField(param) {
    var handleChange = param.handleChange, input = param.input, meta = param.meta, width = param.width, errorMessage = param.errorMessage;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.useDispatch)();
    var locations = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.locations.list;
    });
    var favoriteLocationId = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.me.favoriteLocationId;
    });
    var strings = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var webConfig = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
    var disabled = webConfig.accounts.favorite_location === "disabled";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!disabled) {
            // Assign magicbox parameters
            var magicBox = new _utils_magicBox__WEBPACK_IMPORTED_MODULE_10__/* .MagicBoxParams */ .t().setPagination(1, 50).setSorts({
                state_id: "asc",
                label: "asc"
            });
            // Fetch all locations
            dispatch(_redux_locations_actions__WEBPACK_IMPORTED_MODULE_8__/* .locationsActions.fetchAllLocations */ .b.fetchAllLocations(magicBox));
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_featureAccessor__WEBPACK_IMPORTED_MODULE_3__/* .FeatureAccessor */ .R, {
        featureFlag: _constants_features__WEBPACK_IMPORTED_MODULE_6__/* .FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED */ .y8.ACCOUNT__FAVORITE_LOCATIONS_ENABLED,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_form_fields_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledFormField */ .Ll, {
            width: width,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_selectCheckout__WEBPACK_IMPORTED_MODULE_5__/* .ReduxFormSelect */ .v, {
                errorMessage: errorMessage,
                /** @TODO ensure that `name` is defined. */ // @ts-expect-error
                name: input === null || input === void 0 ? void 0 : input.name,
                handleChange: handleChange,
                optionsArray: (locations === null || locations === void 0 ? void 0 : locations.length) ? (0,_utils_locations__WEBPACK_IMPORTED_MODULE_9__/* .getLocationDataForDropdown */ .Zs)(locations) : [],
                title: (locations === null || locations === void 0 ? void 0 : locations.length) ? (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_11__/* .safelyGetString */ .bc)(strings, "account.add_favorite_location_header") : "Loading Locations...",
                loadingMessage: "Loading Locations...",
                /** @TODO differentiate between `null` and `undefined`. */ // @ts-expect-error
                defaultValue: favoriteLocationId ? favoriteLocationId.toString() : null,
                meta: meta,
                titleEnabled: true
            })
        })
    });
}


/***/ }),

/***/ 83269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ Form; },
  "I": function() { return /* reexport */ Input; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/uielements/forms/field-error.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  position: absolute;\n  top: ",
        "px;\n  font-size: 12px;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FieldError = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    role: "alert"
}).withConfig({
    componentId: "sc-4e59cc64-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.global.error_color;
}, function(param) {
    var theme = param.theme;
    return theme.forms.field_height;
}, function(param) {
    var hidden = param.hidden;
    return hidden && "\n    display: none;\n  ";
});

// EXTERNAL MODULE: ./src/components/uielements/forms/input.tsx
var input = __webpack_require__(23889);
;// CONCATENATED MODULE: ./src/components/uielements/formik/input.tsx







// eslint-disable-next-line react/display-name
var Input = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    // @ts-expect-error: props doesn't match what formik expects
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)(props), 2), field = _$ref[0], _$ref1 = _$ref[1], error = _$ref1.error, touched = _$ref1.touched;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({
                ref: ref
            }, field, props)),
            touched && error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError, {
                children: error
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/uielements/formik/form.tsx

function form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: start;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Form = (0,styled_components_browser_esm/* default */.ZP)(formik_esm/* Form */.l0).withConfig({
    componentId: "sc-f572903-0"
})(form_templateObject());

;// CONCATENATED MODULE: ./src/components/uielements/formik/index.tsx




/***/ }),

/***/ 23889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_visually_hidden__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89785);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40813);





// eslint-disable-next-line react/display-name
var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_visually_hidden__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .f, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: props.id,
                    children: props.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledInput */ .F, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                ref: ref
            }, props))
        ]
    });
});


/***/ }),

/***/ 40813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73393);





var _background_color, _border_radius, _border_color;
var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-a2abffdc-0"
})(function(param) {
    var theme = param.theme, width = param.width;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.forms.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        borderRadius: "".concat((_border_radius = theme.forms.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        border: "1px solid ".concat((_border_color = theme.forms.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        height: "".concat(theme.forms.field_height, "px"),
        padding: "0 var(--size-3)",
        width: width !== null && width !== void 0 ? width : "100%"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.forms.font, [
        "color",
        "font_family",
        "font_size"
    ])), {
        "@media (max-width: 767px)": {
            fontSize: "16px",
            width: "100%"
        },
        "::-webkit-input-placeholder": {
            /* Chrome/Opera/Safari */ color: theme.forms.placeholder_color
        },
        "::-moz-placeholder": {
            /* Firefox 19+ */ color: theme.forms.placeholder_color
        },
        ":-ms-input-placeholder": {
            /* IE 10+ */ color: theme.forms.placeholder_color
        },
        ":-moz-placeholder": {
            /* Firefox 18- */ color: theme.forms.placeholder_color
        },
        "&:focus-within": {
            borderColor: theme.global.primary_active_color
        },
        "&:disabled": {
            background: _constants_styles__WEBPACK_IMPORTED_MODULE_0__/* .COLORS.LIGHTGRAY */ .DM.LIGHTGRAY,
            cursor: "not-allowed"
        }
    });
});


/***/ }),

/***/ 51912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ StyledHr; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  display: block;\n  height: 1px;\n  border: 0;\n  margin: ",
        "px 0;\n  padding: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledHr = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-d8fdad27-0"
})(_templateObject(), function(param) {
    var background = param.background, theme = param.theme;
    return background || theme.global.primary_border_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.MEDIUM */ .jl.MEDIUM);


/***/ }),

/***/ 18368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58408);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3176);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56580);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19663);








var ReCaptcha = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ReCaptcha, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ReCaptcha);
    function ReCaptcha() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, ReCaptcha);
        return _super.apply(this, arguments);
    }
    var _proto = ReCaptcha.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.onRef(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)());
    };
    _proto.render = function render() {
        var ref, ref1, ref2, ref3;
        var _props = this.props, forwardRef = _props.forwardRef, organization = _props.organization, action = _props.action;
        var sitekey = organization === null || organization === void 0 ? void 0 : (ref = organization.external_auth) === null || ref === void 0 ? void 0 : (ref1 = ref.captcha) === null || ref1 === void 0 ? void 0 : ref1.site_key;
        var actions = (organization === null || organization === void 0 ? void 0 : (ref2 = organization.external_auth) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.captcha) === null || ref3 === void 0 ? void 0 : ref3.actions) || [];
        // Ensures we show captcha conditionally to companies that have it enabled.
        if (!sitekey || !actions.includes(action)) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            ref: forwardRef,
            onError: _utils_errorReporter__WEBPACK_IMPORTED_MODULE_7__/* .captureException */ .Tb,
            sitekey: sitekey,
            badge: "bottomright",
            size: "invisible"
        });
    };
    return ReCaptcha;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var mapStateToProps = function(state) {
    return {
        organization: state.app.organization
    };
};
var connector = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__.connect)(mapStateToProps);
/* harmony default export */ __webpack_exports__["Z"] = (connector(ReCaptcha));


/***/ }),

/***/ 39916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MagicBoxParams; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58408);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9850);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72579);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);





var MagicBox = /*#__PURE__*/ function() {
    "use strict";
    function MagicBox() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicBox);
    }
    /**
   * Flatten an object and get paths to all its properties
   *
   * @param object
   * @param path
   * @param paths
   * @returns {*}
   * @TODO improve typing of `object` and `paths`.
   */ MagicBox.flatten = function flatten(object, path, paths) {
        for(var key in object){
            if (object.hasOwnProperty(key)) {
                if (typeof object[key] === "object") {
                    MagicBox.flatten(object[key], "".concat(path, ".").concat(key), paths);
                } else if (path !== "") {
                    paths[key] = "".concat(path.slice(1), ".").concat(key);
                } else {
                    paths[key] = key;
                }
            }
        }
        return paths;
    };
    /**
   * Build arbitrarily nested filters
   *
   * @param filters
   * @param key
   * @returns {Array}
   * @TODO improve typing of `filters`.
   */ MagicBox.buildFilters = function buildFilters(filters, key) {
        // Flatten the filters object to retrieve an object of {column_name: 'path.in.original.object'
        var flattened = MagicBox.flatten(filters, "", {});
        var filterStrings = [];
        for(var column in flattened){
            if (flattened.hasOwnProperty(column)) {
                // Remove column name from path, replace ORs and ANDs
                var orString = flattened[column].toLowerCase().replace(column, "").replace(/or\./g, "[or]").replace(/and\./g, "[and]");
                // Find the filter's value by the retrieved path
                var filter = orString.length === 0 ? filters[column] : lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(filters, flattened[column].replace(column, ""))[column];
                // Build the query param part
                filterStrings.push("".concat(key + orString, "[").concat(column, "]=").concat(filter));
            }
        }
        return filterStrings;
    };
    /**
   * Build a query string (of modifiers) such as per_page, filter, etc
   *
   * Modifiers can look like:
   * const modifiers = {
   * 		filters: {
   * 		    foo: '=bar',
   * 		    or : {
   * 		        baz            : 'bat',
   * 		        'relation.attr': '[1,2,3]'
   * 		    }
   * 		},
   * 		sort   : {
   * 		    'foo': 'asc'
   * 		},
   * 		include: [
   * 		    'foo.bar',
   * 		    'baz.bat',
   * 		]
   * 	};
   *
   * @param {object} modifiers
   * @returns {string}
   * @TODO improve the typing of `modifiers`.
   */ MagicBox.buildUrlModifiers = function buildUrlModifiers(modifiers) {
        var _loop = function(key) {
            // Handle filters and sorts as php assoc. arrays ['key' => 'value']
            if (key === "filters") {
                parts = parts.concat(MagicBox.buildFilters(modifiers[key], key));
            } else if (key === "sort" || key === "aggregate") {
                var part = modifiers[key];
                for(var column in part){
                    if (part.hasOwnProperty(column)) {
                        parts.push("".concat(key, "[").concat(column, "]=").concat(part[column]));
                    }
                }
            } else if (key === "include") {
                // @ts-expect-error
                modifiers[key].forEach(function(relation) {
                    parts.push("include[]=".concat(relation));
                });
            } else {
                // Handle others as objects to be serialized
                parts.push(MagicBox.serialize(modifiers[key]));
            }
        };
        var parts = [];
        for(var key in modifiers)_loop(key);
        if (parts.length > 0) {
            return parts.join("&");
        }
        return "";
    };
    /**
   * Serialize an object into a string of query parameters. This does not return the beginning ?.
   *
   * @param object
   * @returns {string}
   */ MagicBox.serialize = function serialize(object) {
        var parts = [];
        for(var param in object){
            if (object.hasOwnProperty(param)) {
                parts.push("".concat(encodeURIComponent(param), "=").concat(encodeURIComponent(object[param])));
            }
        }
        return parts.join("&");
    };
    /**
   * Break apart a query string into an object
   *
   * @param queryString
   * @returns {{}}
   */ MagicBox.deserialize = function deserialize(queryString) {
        var pairs = queryString.split("&");
        var params = {};
        pairs.forEach(function(pair) {
            var p = pair.split("=");
            params[p[0]] = decodeURIComponent(pair[1] || "");
        });
        return params;
    };
    return MagicBox;
}();
/**
 * A MagicContainer clones itself to prevent weird javascript stuff
 */ var MagicContainer = /*#__PURE__*/ function() {
    "use strict";
    function MagicContainer() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicContainer);
    }
    var _proto = MagicContainer.prototype;
    _proto.clone = function clone() {
        return lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default()(this);
    };
    return MagicContainer;
}();
/**
 * MagicBoxParams is a container for filters, includes, sorts, pagination which get
 * passed to a MagicBox API.
 */ var MagicBoxParams = /*#__PURE__*/ function(MagicContainer) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(MagicBoxParams, MagicContainer);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(MagicBoxParams);
    function MagicBoxParams(filters, sort, include, page, perPage) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicBoxParams);
        var _this;
        _this = _super.call(this);
        _this.without_pagination = false;
        _this.filters = filters || {};
        _this.sort = sort || {};
        _this.include = include || [];
        _this.page = page || 1;
        _this.per_page = perPage || 20;
        return _this;
    }
    var _proto = MagicBoxParams.prototype;
    /**
   * Get the modifier object
   *
   * @returns {object}
   */ _proto.modifiers = function modifiers() {
        return Object.assign({}, {
            filters: this.filters,
            sort: this.sort,
            include: this.include
        });
    };
    /**
   * Get the query for the modifier params
   *
   * @returns {string}
   */ _proto.modifierQuery = function modifierQuery() {
        return MagicBox.buildUrlModifiers(this.modifiers());
    };
    /**
   * Get a pagination object
   *
   * @returns {object}
   */ _proto.pagination = function pagination() {
        return Object.assign({}, {
            page: this.page,
            per_page: this.per_page
        });
    };
    /**
   * Get a pagination query
   *
   * @returns {string}
   */ _proto.paginationQuery = function paginationQuery() {
        return MagicBox.serialize(this.pagination());
    };
    /**
   * Turn a MagicBoxParams container into a query string
   *
   * @returns {string}
   */ _proto.toQuery = function toQuery() {
        var modQ = this.modifierQuery();
        if (!modQ) {
            return this.without_pagination ? "" : this.paginationQuery();
        }
        return this.without_pagination ? "".concat(modQ) : "".concat(modQ, "&").concat(this.paginationQuery());
    };
    /**
   * Set pagination options
   *
   * @param {number} page
   * @param {number} per_page
   * @returns {MagicBoxParams}
   */ _proto.setPagination = function setPagination(page, perPage) {
        this.page = page;
        this.per_page = perPage;
        return this;
    };
    /**
   * Set the filters object
   *
   * @param {object} filters
   * @returns {MagicBoxParams}
   */ _proto.setFilters = function setFilters(filters) {
        /** @TODO improve the typing of `filters`. */ // @ts-expect-error
        this.filters = filters;
        return this;
    };
    /**
   * Add a single filter
   *
   * @param {string} key
   * @param {string} value
   * @returns {MagicBoxParams}
   */ _proto.addFilter = function addFilter(key, value) {
        /** @TODO improve the typing of `filters`. */ // @ts-expect-error
        this.filters[key] = value;
        return this;
    };
    /**
   * Set the sort object
   *
   * @param {object} sort
   * @returns {MagicBoxParams}
   */ _proto.setSorts = function setSorts(sort) {
        /** @TODO improve the typing of `sort`. */ // @ts-expect-error
        this.sort = sort;
        return this;
    };
    /**
   * Add a single sort
   *
   * @param {string} key
   * @param {string} dir
   * @returns {MagicBoxParams}
   */ _proto.addSort = function addSort(key, dir) {
        /** @TODO improve the typing of `sort`. */ // @ts-expect-error
        this.sort[key] = dir;
        return this;
    };
    /**
   * Set the include object
   *
   * @param {string[]} include
   * @returns {MagicBoxParams}
   */ _proto.setIncludes = function setIncludes(include) {
        this.include = include;
        return this;
    };
    /**
   * Add a single include
   *
   * @param {string} include
   */ _proto.addInclude = function addInclude(include) {
        this.include.push(include);
    };
    /**
   * Ignore pagination
   */ _proto.withoutPagination = function withoutPagination() {
        this.without_pagination = true;
        return this;
    };
    return MagicBoxParams;
}(MagicContainer);



/***/ })

}]);